export default __webpack_public_path__ + "static/media/supljivaljak.df793c87.jpg";